import { useState } from "react";
import { delay } from "util/support";
import { FormField, type OnboardingDirectorsAndShareholdersProps } from "../types";
import { ShareholderIdentity } from "../entities";

export const useOtherShareholders = ({ values, setFieldValue }: OnboardingDirectorsAndShareholdersProps) => {
    const [tab, setTab] = useState('1');

    const async = (fn: () => void, timeout = 100) =>
        delay(timeout)
            .finally(fn);

    const addShareholder = () => {
        setFieldValue(FormField.OtherPeople.FieldPrefix, [
            ...values[FormField.OtherPeople.FieldPrefix],
            new ShareholderIdentity()
        ], true);

        async(() => setTab(String(Number(tab) + 1)));
    };

    const deleteShareholder = (index: number) => {
        setFieldValue(
            FormField.OtherPeople.FieldPrefix,
            values[FormField.OtherPeople.FieldPrefix]
                .filter((_, i) => !Object.is(i, index)),
            true
        );

        async(() => setTab(Math.max(Number(tab) - 1, 1).toString()));
    };

    const onChangeTab = (activeTab: string) => setTab(activeTab);

    return {
        tab,
        addShareholder,
        deleteShareholder,
        onChangeTab
    };
};

export default useOtherShareholders;
